<template>
  <button
    :type="type"
    class="
      inline-flex
      items-center
      justify-center
      px-4
      py-2
      h-9
      bg-vice-red
      border border-vice-light-grey
      rounded-md
      text-xs text-white
      hover:bg-red-700
      focus:outline-none
      focus:border-red-700
      focus:ring focus:ring-red-200
      active:bg-red-800
      disabled:opacity-25
      transition
    "
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'button',
    },
  },
};
</script>
